import React, { createContext, useContext, useState } from 'react';
import { ContactForm } from '../components/ui/contact-form';

interface ContactModalContextType {
  isOpen: boolean;
  openModal: (subject?: string) => void;
  closeModal: () => void;
}

const ContactModalContext = createContext<ContactModalContextType | undefined>(undefined);

export function ContactModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState<string>('');

  const openModal = (subject: string = '') => {
    setSubject(typeof subject === 'string' ? subject : '');
    setIsOpen(true);
  };
  
  const closeModal = () => {
    setIsOpen(false);
    setSubject('');
  };

  return (
    <ContactModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
      <ContactForm isOpen={isOpen} onClose={closeModal} initialSubject={subject} />
    </ContactModalContext.Provider>
  );
}

export function useContactModal() {
  const context = useContext(ContactModalContext);
  if (context === undefined) {
    throw new Error('useContactModal must be used within a ContactModalProvider');
  }
  return context;
} 